import { render, staticRenderFns } from "./orderPayBack.vue?vue&type=template&id=187983d8&scoped=true&"
import script from "./orderPayBack.vue?vue&type=script&lang=js&"
export * from "./orderPayBack.vue?vue&type=script&lang=js&"
import style0 from "./orderPayBack.vue?vue&type=style&index=0&id=187983d8&lang=less&scoped=true&"
import style1 from "./orderPayBack.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187983d8",
  null
  
)

export default component.exports